import AppSwitch from '@nxsys/components/AppSwitch';
import Inheritable from '@nxsys/components/Inheritable';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form, Switch } from 'antd';
import React from 'react';
import type { PayrollFinanceSectionProps } from './types';

const ExpenseSection: React.FC<PayrollFinanceSectionProps> = ({
  form,
  watchValues,
  visibility,
}) => {
  const { messages } = useTypedIntl();

  if (!visibility.expense) return null;

  return (
    <div className="pt-6">
      <div className="mb-6 text-xl font-medium text-gray-800">
        {messages['common.expense']}
      </div>
      <Form.Item
        label={messages['common.expenseReceiptUploadMandatory']}
        name={['expense', 'isRequiredAttachmentExpenses']}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 4 }}
      >
        <AppSwitch />
      </Form.Item>
      <Form.Item name={['expense', 'reclaimAppLevy']} className="mt-6" wrapperCol={{ span: 24 }}>
        <Inheritable<boolean>
          label={messages['common.reclaimAppLevyCosts'] as string}
          name={['expense', 'reclaimAppLevy']}
          value={watchValues?.expense?.reclaimAppLevy}
          inheritedValue={false}
          form={form}
        >
          {({ value, onChange, disabled }) => (
            <Switch
              checked={value ?? false}
              disabled={disabled}
              onChange={onChange}
            />
          )}
        </Inheritable>
      </Form.Item>
    </div>
  );
};

export default ExpenseSection;
